<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "Bahn1CountdownTimer",
  data: () => ({
    now: Date.now(),
    interval: null
  }),
  computed: {
    ...mapGetters("bahn1", ["termin"]),
    targetDate() {
      if (!this.termin) return null;
      const date = moment(this.termin.Tag).format("YYYY-MM-DD");
      return new Date(`${date}T${this.termin.Beginn}`);
    },
    remaining() {
      return this.targetDate
        ? Math.max(0, this.targetDate.getTime() - this.now)
        : 0;
    },
    units() {
      const total = this.remaining;
      return [
        { value: Math.floor(total / 86400000), label: "Tage" },
        { value: Math.floor(total / 3600000) % 24, label: "Stunden" },
        { value: Math.floor(total / 60000) % 60, label: "Minuten" },
        { value: Math.floor(total / 1000) % 60, label: "Sekunden" }
      ];
    }
  },
  mounted() {
    this.interval = window.setInterval(() => {
      this.now = Date.now();
    }, 1000);
  },
  beforeDestroy() {
    window.clearInterval(this.interval);
  }
};
</script>

<template>
  <div class="countdown" v-if="termin">
    <div class="countdown-unit" v-for="unit in units" :key="unit.label">
      <span class="countdown-value">{{
        String(unit.value).padStart(2, "0")
      }}</span>
      <span class="countdown-label">{{ unit.label }}</span>
    </div>
  </div>
</template>

<style scoped>
.countdown {
  /* inter-unit gap equals one unit's width */
  --countdown-unit-width: 56px;
  display: flex;
  column-gap: var(--countdown-unit-width);
  color: white;
}
.countdown-unit {
  width: var(--countdown-unit-width);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.countdown-value {
  font-family: "GeometriaMedium";
  font-size: 30px;
  line-height: 1.1;
  margin-bottom: 4px;
}
.countdown-label {
  font-size: 12px;
  white-space: nowrap;
  font-family: "GeometriaLight";
}
@media (max-width: 599px) {
  .countdown {
    --countdown-unit-width: 44px;
    column-gap: 12px;
  }
  .countdown-value {
    font-size: 24px;
  }
}
</style>
